import React, { useState, useRef, useEffect } from "react";
import styles from "./Header.module.scss";
import profile from "../../../assets/svg/profile.svg";
import Notification_icon from "../../../assets/svg/Notification_icon.svg";
import Help_icon from "../../../assets/svg/Help_icon.svg";
import { useNavigate } from "react-router-dom";
import { Paths } from "../../../Routes/path";
import { doLogout } from "../../../common/utility";
import logout_outlined from "../../../assets/svg/logout_outlined.svg";
import { testIds } from "../../../common/testData";

function useOutsideAlerter(ref, cbk) {
  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        cbk(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
    // eslint-disable-next-line
  }, [ref]);
}

const Header = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef, setOpen);

  return (
    <div className={styles.headerComponent} data-testid={testIds['header-component']}>
      <div className={styles.headerElement}>
        <img
          data-testid={testIds['navigate-dashboard']}
          src="https://www.airtel.in/favicon.ico"
          alt="logo"
          width={40}
          height={40}
          className={styles.pointer}
          onClick={() => navigate(Paths.internalDashboard.path)}
        />
      </div>
      <div className={styles.headerElement}>
        <img
          src={Help_icon}
          alt="help"
          width={20}
          height={26}
          className={styles.iconMargin}
        />
        <img
          src={Notification_icon}
          alt="notification"
          width={20}
          height={26}
        />
        <div className={styles.divider} />
        <div className={styles.headerElement}>
          <img
            data-testid={testIds['toggle-open-btn']}
            src={profile}
            alt="profile"
            width={40}
            height={40}
            className={styles.pointer}
            onClick={() => setOpen(!open)}
          />
          {open && (
            <div className={styles.profileDropdown} ref={wrapperRef}
            >
              <div
                className={styles.logout}
                data-testid={testIds['logout-btn']}
                onClick={() => {
                  doLogout();
                }}
              >
                <img src={logout_outlined} alt="logout" />
                Log Out
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Header;
